import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_DESIGNER_DISCOUNT_BANNER_FAILURE,
  CREATE_DESIGNER_DISCOUNT_BANNER_REQUEST,
  GET_ALL_DESIGNER_DISCOUNT_BANNER_SUCCESS,
  GET_ALL_DESIGNER_DISCOUNT_BANNER_REQUEST,
  GET_ALL_DESIGNER_DISCOUNT_BANNER_FAILURE,
  DELETE_DESIGNER_DISCOUNT_BANNER_REQUEST,
  DELETE_DESIGNER_DISCOUNT_BANNER_FAILURE,
  UPDATE_DESIGNER_DISCOUNT_BANNER_REQUEST,
  UPDATE_DESIGNER_DISCOUNT_BANNER_FAILURE,
  DELETE_DESIGNER_DISCOUNT_BANNER_SUCCESS,
  CREATE_DESIGNER_DISCOUNT_BANNER_SUCCESS,
  UPDATE_DESIGNER_DISCOUNT_BANNER_SUCCESS
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllDesignerDiscountBanner = () => async (dispatch) => {
  dispatch({ type: GET_ALL_DESIGNER_DISCOUNT_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/designerDiscountBanners`);
    dispatch({ type: GET_ALL_DESIGNER_DISCOUNT_BANNER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_DESIGNER_DISCOUNT_BANNER_FAILURE, payload: error.message });
  }
};

export const createDesignerDiscountBanner = (designerDiscountBannerData, formData, handleCancle) => async (dispatch) => {
  dispatch({ type: CREATE_DESIGNER_DISCOUNT_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/designerDiscountBanner`, designerDiscountBannerData);

    if (data && data.id) {
      const uploadResponse = await privateAxios.put(
        `admin/designerDiscountBanner/${data.id}/upload`,
        formData // image data
        // 👇 Don’t manually set content-type, browser/axios sets it correctly with boundary
      );
      dispatch(getAllDesignerDiscountBanner());
      toast.success("Designer Discount Banner Uploaded Successfully !!");
      dispatch({ type: CREATE_DESIGNER_DISCOUNT_BANNER_SUCCESS, payload: data });
      handleCancle();
    }
  } catch (error) {
    console.error("Error creating/uploading Designer Discount Banner:", error);

    const errorMsg =
      error?.response?.data?.status === "FAIL"
        ? error.response.data.response
        : "Failed Designer Discount Banner Creations !!";

    toast.error(errorMsg);
    dispatch({ type: CREATE_DESIGNER_DISCOUNT_BANNER_FAILURE, payload: errorMsg });
  }
};


export const updateDesignerDiscountBanner = (designerDiscountBannerId, designerDiscountBannerData, formData, handleCancle) => async (dispatch) => {
  dispatch({ type: UPDATE_DESIGNER_DISCOUNT_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/designerDiscountBanner/${designerDiscountBannerId}`,
      designerDiscountBannerData
    );
    if (data.status === "SUCCESS") {
      if (formData && formData.get("imageFile") && formData.get("imageFile").name) {
        const uploadResponse = await privateAxios.put(
          `admin/designerDiscountBanner/${data.response.id}/upload`,
          formData // image data
          // 👇 Don’t manually set content-type, browser/axios sets it correctly with boundary
        );
      }
      dispatch(getAllDesignerDiscountBanner());
      toast.success("Designer Discount Banner Updated Successfully");
      dispatch({ type: UPDATE_DESIGNER_DISCOUNT_BANNER_SUCCESS, payload: data });
      handleCancle();
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_DESIGNER_DISCOUNT_BANNER_FAILURE, payload: error.message });
  }
};

export const deleteDesignerDiscountBanner = (designerDiscountBannerId) => async (dispatch) => {
  dispatch({ type: DELETE_DESIGNER_DISCOUNT_BANNER_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/designerDiscountBanner/${designerDiscountBannerId}`);
    if (data.status === "SUCCESS") {
      dispatch({ type: DELETE_DESIGNER_DISCOUNT_BANNER_SUCCESS, payload: designerDiscountBannerId })
      dispatch(getAllDesignerDiscountBanner());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_DESIGNER_DISCOUNT_BANNER_FAILURE, payload: error.message });
  }
};
